import Info from '@mui/icons-material/Info';
import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
import React from 'react';

const PREFIX = 'PropertiesButton';

const classes = {
  icon: `${PREFIX}-icon`
};

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  [`& .${classes.icon}`]: {
    float: 'right',
    verticalAlign: 'middle',
    cursor: 'pointer',
    color: theme.palette.primary.main
  }
}));

interface PropertiesButtonProps {
  onClick: (e: any) => void;
  className: string;
}
const PropertiesButton = ({ onClick, className, ...rest }: PropertiesButtonProps) => {
  return (
    <StyledIconButton
      className={className}
      size="small"
      aria-label="properties"
      onClick={onClick}
      {...rest}
    >
      <Tooltip title="properties">
        <Info className={classes.icon} />
      </Tooltip>
    </StyledIconButton>
  );
};

export default PropertiesButton;
